import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { CityOfSearchModal } from '@doda/common/src/models/MasterCacheModel';

/**
 * 市区町村のAPIリクエスト作成
 * @param queryParams クエリパラメータ
 * @param cities 市区町村のマスタ
 * @returns 市区町村のAPIリクエスト
 */
export const createCitiesApiRequest = (
  queryParams: AppQueryParams,
  cities: CityOfSearchModal[] | null
) => {
  let citiesName = '';
  let ci = '';
  let requestCitiesId: string[] | undefined = [];

  // 政令指定都市（市）
  const ordinanceDesignatedCityList = cities?.filter(
    (city) => city.isOrdinanceDesignatedCity === true
  );

  if (queryParams.ci) [ci] = queryParams.ci;
  const findCi = ordinanceDesignatedCityList?.find(
    (ordinanceDesignatedCity) => ordinanceDesignatedCity.id === ci
  );
  if (findCi) {
    citiesName = findCi.name;
    requestCitiesId = queryParams.ci;
  } else {
    throw new Error('パラメータの不正(ci)');
  }

  return { citiesName, requestCitiesId };
};
